export const animalData = {
  // ═══════════════════════════════════════
  // HANDS-ON ENCOUNTERS
  // ═══════════════════════════════════════
  handsOnEncounters: [
    {
      id: 'lemur-encounter',
      name: '(2) Lovable Lemurs',
      description: 'Includes both friendly, interactive lemurs for petting, feeding & photos. Watch them jump 8\' onto your guests!',
      price: 995,
      additionalHourPrice: 497.5,
      category: 'encounter',
      image: '/animals/lemur-monkeys.jpg',
      imagePosition: 'center 20%',
    },
    {
      id: 'exotic-birds',
      name: '(4) Exotic Birds',
      description: 'Includes (4) highly trained macaws & cockatoos; photo-friendly & display-ready. Incredible photo opps & audience interaction.',
      price: 1250,
      additionalHourPrice: 625,
      category: 'encounter',
      image: '/animals/exotic-birds.jpg',
    },
    {
      id: 'capuchin-monkey',
      name: '(1) Capuchin Monkey',
      description: 'Super cute, but is NOT hands-on. Can be roaming, only held by handler.',
      price: 1500,
      additionalHourPrice: 750,
      category: 'encounter',
      image: '/animals/capuchin-monkey.jpg',
    },
    {
      id: 'full-interactive',
      name: '(7-8) Interactive Animals',
      description: 'A curated collection of 7-8 interactive animals, rotating for a Hands-On Show-&-Tell experience you\'ll never forget! Choose your preference, however specific animals delivered will be based on availability.',
      price: 1450,
      additionalHourPrice: 0,
      category: 'encounter',
      image: '/animals/full-interactive.jpg',
    },
  ],

  // Team lists for the Full Interactive Package
  teamLists: {
    team1: ['Lemur', 'Tortoise', 'Friendly Snake', 'Small Alligator', 'Dancing Cockatoo', 'Lavender Skunk', 'Baby Goat', 'Chinchilla'],
    team2: ['Honeybear Kinkajou', 'Turtle', 'Friendly Snake', 'Small Alligator', 'Macaw', 'Fennic Fox', 'Bearded Dragon', 'Chinchilla'],
  },

  // ═══════════════════════════════════════
  // BIG CATS
  // ═══════════════════════════════════════
  bigCats: [
    {
      id: 'bengal-tiger',
      name: 'Bengal Tiger',
      image: '/animals/bengal-tiger.jpg',
      maxQty: 2,
    },
    {
      id: 'white-tiger',
      name: 'White Tiger',
      image: '/animals/white-tiger-calm.jpg',
      maxQty: 1,
    },
    {
      id: 'male-lion',
      name: 'Male Lion',
      image: 'https://images.unsplash.com/photo-1765170503874-0517032bc3f2?w=800&q=80',
      maxQty: 1,
    },
  ],
  bigCatPricing: [
    { id: 'first-big-cat', name: '1st Big Cat', price: 3500, description: 'Lion or Tiger' },
    { id: 'second-big-cat', name: '2nd Big Cat', price: 1995, description: 'Additional lion or tiger' },
    { id: 'third-big-cat', name: '3rd Big Cat', price: 1500, description: 'Additional lion or tiger' },
    { id: 'steel-arena', name: '20\' Steel Arena', price: 995, description: 'Optional arena upgrade' },
  ],

  // ═══════════════════════════════════════
  // EXTRAORDINARY ANIMALS
  // ═══════════════════════════════════════
  extraordinaryAnimals: {
    row1: [
      {
        id: 'giraffe',
        name: 'Giraffe',
        description: 'Interactive feeding & display in secure enclosure. Up to 3 hours.',
        price: 9900,
        category: 'extraordinary',
        image: 'https://images.pexels.com/photos/18030750/pexels-photo-18030750.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        id: 'zebra',
        name: 'Zebra',
        description: 'Adult zebra, supervised touching & photo display. Up to 3 hours.',
        price: 3500,
        category: 'extraordinary',
        image: 'https://images.unsplash.com/photo-1501706362039-c06b2d715385?w=800&q=80',
      },
      {
        id: 'giraffe-zebra-package',
        name: 'Giraffe + Zebra Package',
        description: 'Two separate enclosures; giraffe feeding experience included. Up to 3 hours.',
        price: 13500,
        category: 'extraordinary',
        image: '/animals/giraffe-zebra-package.jpg',
      },
    ],
    row2: [
      {
        id: 'camel',
        name: 'Camel',
        description: 'Friendly adult camel for display & supervised interaction. Up to 2 hours.',
        price: 1800,
        category: 'extraordinary',
        image: '/animals/camel-clean.jpg',
        hasRideAddon: true,
      },
      {
        id: 'flamingo-display',
        name: 'Flamingos',
        description: '(2) live flamingos presented in custom pond with ferns & foliage. Flat rate (Miami-based).',
        price: 5000,
        category: 'extraordinary',
        image: 'https://images.unsplash.com/photo-1497206365907-f5e630693df0?w=800&q=80',
        hasFlamingoAddon: true,
      },
      {
        id: 'elephant',
        name: 'Adult Elephant',
        description: 'Display experience with professional handler team; optional VIP ride with conditions met. Up to 3 hours.',
        price: 16000,
        category: 'extraordinary',
        image: '/animals/elephant.jpg',
      },
    ],
    row3: [
      {
        id: 'brown-horse',
        name: 'Brown Horse',
        description: 'Riding or grooming experience. 1 hour.',
        price: 1200,
        category: 'extraordinary',
        image: 'https://images.unsplash.com/photo-1686382951211-f882fcd3e48e?w=800&q=80',
      },
      {
        id: 'white-horse',
        name: 'White Horse',
        description: 'Riding or grooming experience. 1 hour.',
        price: 1800,
        category: 'extraordinary',
        image: '/animals/white-horse.jpg',
      },
      {
        id: 'kangaroo-wallaby',
        name: 'Kangaroo / Wallaby',
        description: 'Interactive encounter with a friendly kangaroo or wallaby.',
        price: 3200,
        category: 'extraordinary',
        image: 'https://images.unsplash.com/photo-1770525149732-43db0df3eac3?w=800&q=80',
      },
    ],
  },

  // ═══════════════════════════════════════
  // LUXURY PETTING ZOO
  // ═══════════════════════════════════════
  pettingZoo: {
    id: 'luxury-petting-zoo',
    name: 'Luxury Petting Zoo',
    description: 'Includes up to 2 hours of hands-on fun with enclosure and tent if required. Animals can include: world\'s smallest cow, mini donkeys, llama, mini goats, baby lambs, sheep, mini pigs, satin chicks, bunnies, and/or mini white ducks.',
    price: 1200,
    category: 'petting-zoo',
    image: '/animals/petting-zoo.jpg',
  },
  pettingZooAddons: [
    {
      id: 'pony-addon-1hr',
      name: 'Pony Rides (1 Hour)',
      price: 500,
      category: 'petting-zoo-addon',
    },
    {
      id: 'pony-addon-2hr',
      name: 'Pony Rides (2 Hours)',
      price: 750,
      category: 'petting-zoo-addon',
    },
  ],

  // ═══════════════════════════════════════
  // PROPS & DECOR
  // ═══════════════════════════════════════
  props: {
    fiberglass: {
      id: 'fiberglass-props',
      name: 'Large Fiberglass Props',
      priceEach: 0,
      quotePending: true,
      category: 'props',
      options: [
        { id: 'lion-prop', name: 'Lion', image: '/props/lion-prop.jpg' },
        { id: 'black-panther-prop', name: 'Black Panther', image: '/props/black-panther-prop.jpg' },
        { id: 'black-panther-prop-2', name: 'Black Panther (Alt)', image: '/props/black-panther-prop-2.jpg' },
        { id: 'gorilla-prop', name: 'Gorilla', image: '/props/gorilla-prop.jpg' },
        { id: 'gorilla-sitting-prop', name: 'Gorilla Sitting', image: '/props/gorilla-sitting-prop.jpg' },
        { id: 'elephant-prop', name: 'Elephant & White Tiger', image: '/props/elephant-white-tiger-props.jpg' },
        { id: 'rent-elephant-prop', name: 'Elephant', image: '/props/rent-a-prop-elephant.jpg' },
        { id: 'giraffe-prop', name: 'Giraffe', image: '/props/giraffe-prop.jpg' },
        { id: 'zebra-prop', name: 'Zebra', image: '/props/zebra-prop.jpg' },
        { id: 'rhino-wall-prop', name: 'Rhino & Wall', image: '/props/rhino-wall-prop.jpg' },
      ],
    },
    lighting: {
      id: 'accent-lighting',
      name: 'Accent Lighting',
      baseCount: 12,
      basePrice: 600,
      addonCount: 6,
      addonPrice: 300,
      category: 'props',
      image: '/props/accent-lighting.jpg',
    },
    trees: {
      id: 'jungle-trees',
      name: 'Jungle Trees & Hanging Vines',
      baseCount: 6,
      basePrice: 600,
      addonCount: 6,
      addonPrice: 350,
      category: 'props',
      image: '/props/jungle-trees.jpg',
    },
    other: [
      {
        id: 'safari-signage',
        name: 'Custom Safari Entrance Signage',
        price: 995,
        category: 'props',
        image: '/props/safari-signage.jpg',
      },
      {
        id: 'lion-king-signage',
        name: 'Lion King Signage',
        price: 995,
        category: 'props',
        image: '/props/lion-king-signage.jpg',
      },
      {
        id: 'hedge-wall',
        name: 'Custom Hedge Wall Photo Backdrop',
        price: 995,
        category: 'props',
        image: '/props/custom-hedge-wall.jpg',
      },
      {
        id: 'custom-signage',
        name: 'Custom Signage & Printed Decor',
        price: 500,
        priceNote: '$500+',
        category: 'props',
        image: '/props/custom-signage.jpg',
      },
    ],
  },
};
